export default function SidenavHeader() {
  return (
    <div className="bg-gray-900 flex items-center justify-center mb-6 pb-6 pt-3 sticky top-0 z-10">
      <img
        src="https://i.pinimg.com/280x280_RS/ab/a2/8e/aba28eb29f66aab5f24db128a0232f3f.jpg"
        alt="Roger NDUTIYE"
        className="h-10 mx-auto object-cover rounded-full w-10"
      />
    </div>
  );
}
